let productDetails = {};

(function (productDetailsApp) {
    $(document).ready(function () {
        $(document).on("change", ".js-option-variant", function (e) {
            $(".js-subtotal").text(`$${$(this).data("price")}`);
        });
    });

})(productDetails);
